import React, { useState, useRef, useEffect } from "react"

export default function ShowcaseVideoComponent({ video, thumbnailImage, title }) {
  //if we dont end up using a hook, just remove it.
  const [showThumbnail, setShowThumbnail] = useState(true)
  const [fadeInVideo, setFadeInVideo] = useState(true)
  const videoRef = useRef(null)

  const handlePlay = () => {
    setShowThumbnail(!showThumbnail)
    const videoplayer = videoRef.current
    setTimeout(() => {
      videoplayer.currentTime = 0
      setTimeout(() => {
        setFadeInVideo(false)
        videoplayer.play()
      }, 50) // combats the weird iOS issue
    }, 50)
  }

  useEffect(() => {
    const videoplayer = videoRef.current

    const resetAndPlayVideo = () => {
      videoplayer.pause()
      videoplayer.currentTime = 0
      videoplayer.play().catch((error) => {
        console.error("Playback failed: ", error)
      })
      videoplayer.removeEventListener("canplaythrough", resetAndPlayVideo)
    }

    if (videoplayer && !showThumbnail) {
      if (videoplayer.readyState >= 4) {
        resetAndPlayVideo()
      } else {
        videoplayer.addEventListener("canplaythrough", resetAndPlayVideo)
      }
    }

    return () => {
      if (videoplayer) {
        videoplayer.removeEventListener("canplaythrough", resetAndPlayVideo)
      }
    }
  }, [showThumbnail])

  return (
    <div className="showcase-video-container">
      <h2 data-epi-property="Title">{title}</h2>
      <div className={"showcase-video-content"}>
        <video
          ref={videoRef}
          data-epi-property="Video"
          controls
          playsInline={true}
          hidden={showThumbnail}
          className={`showcase-video ${fadeInVideo ? "fadeInFromBlackBefore" : "fadeInFromBlackAfter"}`}
          src={video}
        ></video>
        {showThumbnail ? (
          <button className="showcase-video-thumbnail" onClick={() => handlePlay()}>
            <img data-epi-property="ThumbnailImage" src={thumbnailImage}></img>
            <div className="svg-container">
              <svg className={`svg-icon svg-icon--playcircle`}>
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`/dist/svg/symbols.svg#svg-playcircle`}>
                  &nbsp;
                </use>
              </svg>
            </div>
          </button>
        ) : undefined}
      </div>
    </div>
  )
}
